import { Injectable } from '@angular/core';
import { NuveiCard } from '../models/nuvei.model';
import { AngularFirestore, CollectionReference } from '@angular/fire/compat/firestore';
import { CredentialsService } from '@app/auth';
import { GeneralService } from './general.service';
import { Logger } from '../logger.service';
import { HttpService } from './http.service';
import { environment } from '@env/environment';

const log = new Logger('nuvei-service');

export interface GetAccountCaptureResponse {
  redirectUrl: string;
  userTokenId: string;
  sessionToken: string;
  internalRequestId: number;
  status: string;
  errCode: number;
  reason: string;
  merchantId: string;
  merchantSiteId: string;
  version: string;
}

@Injectable({
  providedIn: 'root',
})
export class NuveiService {
  private collection: CollectionReference<NuveiCard>;

  constructor(
    private firestore: AngularFirestore,
    private credentialsS: CredentialsService,
    private generalS: GeneralService,
    private httpS: HttpService
  ) {
    this.collection = this.firestore.collection<NuveiCard>('nuvei-cards').ref;
  }

  async getCards(): Promise<NuveiCard[]> {
    try {
      const credentials = this.credentialsS.credentials!;
      const customer = this.generalS.getRef(credentials.id, 'customers');
      const data = await this.collection.where('customer', '==', customer).get();
      const cards: NuveiCard[] = data.docs.map((d) => {
        return { ...d.data(), id: d.id };
      });

      return cards;
    } catch (error) {
      log.error(error);
      return [];
    }
  }

  async saveUpo(userPaymentOptionId: string, last4Digits: string) {
    try {
      const url = environment.api.nuvei.url;
      const data = await this.httpS.post(url, {
        userPaymentOptionId,
        last4Digits,
      });

      if (data) {
        const card = (data.data as { card: NuveiCard })['card'];
        return card;
      }
    } catch (error) {
      log.error(error);
    }

    return null;
  }

  async getUpo(cardId: string) {
    try {
      const url = `${environment.api.nuvei.url}/${cardId}`;
      const response = await this.httpS.get(url);
      if (response) {
        const upo = (response.data as { userPaymentOptionId: string }).userPaymentOptionId;
        return upo;
      }
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async saveUser() {
    log.info('guardare info');
    const path = 'save-user-nuvei';
    const data = localStorage.getItem(path);

    if (data) {
      const weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate() - 7);

      if (+data > weekAgo.getTime()) {
        log.info('omitire guardare info');
        return null;
      }
    }

    localStorage.setItem(path, `${new Date().getTime()}`);

    try {
      const url = `${environment.api.nuvei.url}/saveUserData`;
      const response = await this.httpS.post(url, {});
      if (response) {
        log.info('response save user nuveio', response);
      }
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async getAccountCapture() {
    try {
      const url = `${environment.api.nuvei.url}/getAccountCapture`;
      const response = await this.httpS.post(url, {});
      if (response) {
        log.info(response);
        const upo = (response as any).capture as GetAccountCaptureResponse;
        return upo;
      }
    } catch (error) {
      log.error(error);
    }
    return null;
  }

  async removeCard(paymentData: any) {
    try {
      const url = `${environment.api.nuvei.url}/deleteCard`;
      const response = await this.httpS.post(url, { paymentData });
      if (response) {
        log.info('response delete card', response);
      }
    } catch (error) {
      log.error(error);
    }
  }
}
